import { isRSC } from "@tamagui/constants";
import { useRef, useState } from "react";
const useServerState = isRSC ? (val) => [val, idFn] : useState;
const useServerRef = isRSC ? (val) => ({ current: val }) : useRef;
const idFn = () => {
};
export {
  useServerRef,
  useServerState
};
//# sourceMappingURL=useServerHooks.js.map
